import { Card } from "@mantine/core";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useColors } from "../../../hooks/colors/useColors";
import { isPhone } from "../../../constants/env";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import classes from "./specialties.module.css";

type InputProps = {
  href: string;
  image: string;
  title: string;
  description: string;
};

export function SpecialtyCard({ image, title, description, href }: InputProps) {
  const { colors } = useColors();
  const { t } = useTranslation("common");

  return (
    // <Link href={href}>
    <Card
      radius="xl"
      withBorder
      style={{ maxWidth: isPhone ? 360 : 400, zIndex: 0 }}
      className="my-6 hover:cursor-pointer hover:shadow-2xl"
    >
      <Card.Section>
        <Image
          src={image}
          height={300}
          alt={title}
          width={400}
          style={{
            objectFit: "cover",
          }}
        />
      </Card.Section>

      <h1
        className="text-center text-3xl"
        style={{
          color: colors.secondary,
          fontWeight: 700,
          textTransform: "uppercase",
        }}
      >
        {title}
      </h1>

      <div className="px-2 mb-6">
        <span
          className={`${classes.description} text-xl`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
      <div className="flex items-center justify-center mb-4">
        <ButtonLink
          href={href}
          color={colors.secondary}
          title={t("read")}
          rounded
        />
      </div>
    </Card>
    // </Link>
  );
}
